"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlBuffer = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IGlBuffer}
 */
class GlBuffer {
    constructor(data, ctor) {
        this.data = data;
        this.ctor = ctor;
        this.changeId = -1;
        this.isDirty = true;
        this.buffer = null;
        this.mutatorId = -1;
        this.modificationId = -1;
        this.byteSize = -1;
        this.updateSizeFromArray(data);
    }
    onContextLost() {
        this.resetState();
        this.buffer = null;
    }
    initialize(context) {
        if (this.buffer == null) {
            this.buffer = context.createBuffer();
        }
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.buffer != null, "failed to create buffer");
    }
    destroy(context) {
        context.deleteBuffer(this.buffer);
        // resetting the state allows the state to be reinitialized
        this.resetState();
        this.buffer = null;
    }
    resetState() {
        this.isDirty = true;
        this.changeId = -1;
        this.mutatorId = -1;
        this.modificationId = -1;
        this.byteSize = -1;
    }
    setSize(context, byteSize, usage, changeId) {
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            rc_js_util_1._Debug.assert(changeId !== -1, "found changeId that was not initialized");
            rc_js_util_1._Debug.assert(this.buffer != null, "expected buffer to be initialized");
        });
        if (this.changeId === changeId) {
            return;
        }
        this.data = null;
        this.changeId = changeId;
        context.bindBuffer(context.ARRAY_BUFFER, this.buffer);
        context.bufferData(context.ARRAY_BUFFER, byteSize, usage);
        this.byteSize = byteSize;
    }
    setData(data, changeId) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(changeId !== -1, "found changeId that was not initialized");
        if (this.changeId === changeId) {
            return;
        }
        this.changeId = changeId;
        this.isDirty = true;
        this.data = data;
        this.updateSizeFromArray(data);
    }
    bindArray(context, usage) {
        context.bindBuffer(context.ARRAY_BUFFER, this.buffer);
        if (this.isDirty) {
            DEBUG_MODE && rc_js_util_1._Debug.assert(this.data != null, "expected data to have been set");
            const data = DEBUG_MODE ?
                rc_js_util_1.DebugProtectedView.unwrapProtectedView(this.data)
                : this.data;
            context.bufferData(context.ARRAY_BUFFER, data, usage);
            this.isDirty = false;
        }
    }
    bindTransform(context, index) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.buffer != null, "expected buffer to be initialized");
        context.bindBufferBase(context.TRANSFORM_FEEDBACK_BUFFER, index, this.buffer);
        this.isDirty = false;
    }
    getSubBufferData(context, result = new this.ctor(this.byteSize / this.ctor.BYTES_PER_ELEMENT)) {
        context.bindBuffer(context.ARRAY_BUFFER, this.buffer);
        context.getBufferSubData(context.ARRAY_BUFFER, 0, result);
        return result;
    }
    setSubBufferData(context, byteOffset, data, changeId, modificationId) {
        if (this.mutatorId === changeId) {
            if (modificationId < this.modificationId) {
                return;
            }
            else {
                this.modificationId = modificationId;
            }
        }
        else {
            this.modificationId = modificationId;
        }
        context.bufferSubData(context.ARRAY_BUFFER, byteOffset, data);
        this.mutatorId = changeId;
    }
    updateSizeFromArray(data) {
        this.byteSize = data == null
            ? -1
            : data.byteLength;
    }
}
exports.GlBuffer = GlBuffer;
//# sourceMappingURL=gl-buffer.js.map